/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  $(document).ready(function(){
    $('[data-bs-toggle="tooltip"]').tooltip();   
  });
  const variant_id = $('.card-radio:checked').val();

  let originalOpen = XMLHttpRequest
    .prototype
    .open

    XMLHttpRequest
    .prototype
    .open = function() {
    this.addEventListener('loadend', ajaxLoadEndListener)
    originalOpen.apply(this, arguments)
  }
  function ajaxLoadEndListener() {
    if (this._url == '/cart/add.js') {
      var response = $.parseJSON(this.response);

      if (response.variant_id != variant_id) {
        $.getJSON('/cart.js', function(cart) {

          //console.log(cart);

          var current_item = cart.items.find(i => i.variant_id === variant_id)
          console.log(current_item)
          var message = $("#CardMessage").val();
          if (current_item) {
            $.ajax({
              url: '/cart/change.js',
              type: 'POST',
              dataType: 'json',
              data: {
                'id': current_item.key,
                'properties': {
                  'Card Message': (message.length > 0)
                    ? message
                    : 'Blank Card'
                }
              },
              success: function(response) {
                console.log(response)
              }
            })

          } else {

            $.ajax({
              url: '/cart/add.js',
              type: 'POST',
              dataType: 'json',
              data: {
                items: [
                  {
                    quantity: 1,
                    id: variant_id,
                    properties: {
                      'Card Message': (
                        (message.length > 0)
                          ? $("#CardMessage").val()
                          : 'Blank Card'
                      )
                    }
                  }
                ]
              },
              success: function(response) {}
            })
          }
        });
      }
    }
    this.removeEventListener('loadend', ajaxLoadEndListener)
  }

  $(document).ready(function() {
    $("body").on("click", ".leave-blank", function() {
      var cartSI = $("#CardMessage");

      if ($(this).prop("checked")) {
        $(this).attr("value", "Yes")
        cartSI.val("BLANK");
        cartSI.prop("readonly", true);
        cartSI.removeClass('is-invalid');
        cartSI.removeAttr('required');
      } else {
        cartSI.val("");
        cartSI.attr("placeholder", "Type your message...")
        cartSI.prop("readonly", false);
        cartSI.next('.invalid-feedback').show();
        cartSI.addClass('is-invalid');
        cartSI.attr('required', true);
      }
    });

    $("body").on("click", ".card-radio", function() {
      let cardType = $(this).attr('alt');
      $("#card-type").text(cardType);
    });

    $("body").on("click", ".with__card-radio", function(e) {
      const container = $(this).parents('.card-options-container');
      let cartSI = container.find(".card-message");
      let withCard = container.find(".with__card-radio:checked").val()
      $("#with--card").text(withCard);
      if (withCard == 'NO CARD*') {
        cartSI.val("");
        cartSI.attr("placeholder", "Blank Card");
        cartSI.attr("readonly");
        cartSI.removeClass('is-invalid');
        cartSI.removeAttr('required');
        container.find(".card-options").hide();
        //$(".card-options").hide();
        if (container.find(".leave-blank").prop("checked")) {
          container.find(".leave-blank").prop("checked", false);
        }
        $(".card-radio:checked").prop("checked", false);
      } else {
        container.find(".card-message").val("");
        container.find(".card-options").show();
        cartSI.attr("placeholder", "Type your message...")
        cartSI.attr("readonly", false);
        cartSI.next('.invalid-feedback').show();
        cartSI.addClass('is-invalid');
        cartSI.attr('required', true);
        container.find(".card-radio:first").prop("checked", true);
      }
    });
    $(".card-radio:checked").click();
  });




